// Practice-session telemetry bindings. Mirrors iOS SessionsEndpoints + /sessions/*.
// One session per play; one attempt per graded question; complete at the end.
import { api } from "./client";
import type {
  AttemptResponse,
  SessionCompleteResponse,
  SessionStartResponse,
} from "./library-types";

export function startSession(questionSetId: string): Promise<SessionStartResponse> {
  return api.post<SessionStartResponse>("/sessions/start", {
    question_set_id: questionSetId,
  });
}

export interface AttemptInput {
  questionId: string;
  correct: boolean;
  responseTimeMs?: number;
  topicSlug?: string;
  // Partial grading. For multi-part items the server recomputes the
  // authoritative score from correctParts/totalParts. Omitted for
  // single-response items → server falls back to `correct`.
  score?: number;
  correctParts?: number;
  totalParts?: number;
}

export function recordAttempt(sessionId: string, input: AttemptInput): Promise<AttemptResponse> {
  return api.post<AttemptResponse>(`/sessions/${encodeURIComponent(sessionId)}/attempt`, {
    question_id: input.questionId,
    correct: input.correct,
    response_time_ms: input.responseTimeMs,
    topic_slug: input.topicSlug,
    // Only present when the item is multi-part, so binary attempts keep the
    // legacy wire shape.
    score: input.score,
    correct_parts: input.correctParts,
    total_parts: input.totalParts,
  });
}

export function completeSession(sessionId: string): Promise<SessionCompleteResponse> {
  return api.post<SessionCompleteResponse>(`/sessions/${encodeURIComponent(sessionId)}/complete`);
}
